export class TicketRequest {
  constructor(
    public account: string | null,
    public ticketId: string | null,
    public amount: number | null
  ) {}
}
